import React, { useState } from "react";
import { ResponsiveTabs } from "../../../Components/Common/DashboardKit";

/**
 * DmsTabs — tab wrapper for DMS document create/edit pages.
 *
 * Visual upgrade: the bespoke purple-pill tab strip has been replaced
 * with the kit's ResponsiveTabs (underline / primary variant), matching
 * the tab style used everywhere else in the dashboard (TaskManagement,
 * EPO/AllTasks, HumanResource, etc.).
 *
 * Public API is UNCHANGED:
 *   <DmsTabs tabs={[{ key, label }]}>
 *     {(activeTab) => <YourPanel forKey={activeTab} />}
 *   </DmsTabs>
 *
 * State (activeTab) and the render-prop children pattern are preserved
 * exactly. The kit's ResponsiveTabs only renders the tab strip — the
 * content is still rendered below by the consumer.
 */
const DmsTabs = ({ tabs, children }) => {
    const [activeTab, setActiveTab] = useState(tabs?.[0]?.key || "");

    return (
        <>
            <ResponsiveTabs
                tabs={tabs}
                activeKey={activeTab}
                onChange={setActiveTab}
                variant="underline"
                color="primary"
            />
            <div style={{ paddingTop: 16 }}>
                {typeof children === "function" ? children(activeTab) : null}
            </div>
        </>
    );
};

export default DmsTabs;
